/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_RetryInputs */

const en_us2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const pt_br2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar de novo`)
};

const es_419_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const pt_pt2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar outra vez`)
};

const fr_fr2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_de2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const it_it2_wrapped_retry = /** @type {(inputs: Wrapped_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Wrapped_RetryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_retry = /** @type {((inputs?: Wrapped_RetryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_RetryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_retry(inputs)
	if (locale === "es-419") return es_419_wrapped_retry(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_retry(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_retry(inputs)
	if (locale === "de-DE") return de_de2_wrapped_retry(inputs)
	if (locale === "it-IT") return it_it2_wrapped_retry(inputs)
	return en_us2_wrapped_retry(inputs)
});
export { wrapped_retry as "wrapped.retry" }